/* @ngInject */
function CampaignHeaderToolbarController ($scope, $translate, $timeout, $element, $filter) {
  const api = {
  }

  this.getApi = () => api

  function activate () {
  }

  activate()

  $scope.getGroupsTooltip = (groups) => {
    if (!groups?.length) return

    const groupsText = groups.map(group => group.name).join('<br/>')
    $timeout(() => {
      jQuery($element).find('.designers-list-tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 150, false)
    return groupsText
  }

  $scope.getStatusTag = (campaign) => {
    if (campaign.isArchived) {
      return { type: 'grey', label: $translate.instant('campaignsModule.status.archived') }
    }

    const statusConfig = {
      WAITING: { type: 'yellow', label: $translate.instant('campaignsModule.status.waiting') },
      IN_PROGRESS: { type: 'blue', label: $translate.instant('campaignsModule.status.inProgress') },
      FINISHED: { type: 'green', label: $translate.instant('campaignsModule.status.finished') },
      LATE: { type: 'red', label: $translate.instant('campaignsModule.status.late') }
    }

    return statusConfig[campaign.status] || { type: 'grey', label: $translate.instant('campaignsModule.status.unknown') }
  }

  $scope.getFormattedStartDate = (campaign) => {
    if (!campaign || !campaign.startDate) return ''
    const startYear = new Date(campaign.startDate).getFullYear()
    const endYear = new Date(campaign.deliveryDate).getFullYear()
    const chosenFilter = startYear !== endYear ? 'dateMediumShortYearFilter' : 'dateShortFilter'
    return $filter(chosenFilter)(campaign.startDate)
  }
}

export { CampaignHeaderToolbarController }
